// extracted by mini-css-extract-plugin
export default {"main":"znCxY","background":"NG0yD"};